import React from "react";
import "./Certificate.css";

function Certificate() {
    return (
        <div className="certContainer">
            <div className="certleft">
                <p>
                    Jul 2025 <br />
                    <i>Certification was issued</i>

                </p>
                <p>Apr 2025 <br />
                    <i>Certification was issued</i>
                </p>

                <p>Feb 2024 <br />
                    <i>Certification was issued</i>
                </p>
                <p>Jan 2024 <br />
                    <i>Certification was issued</i>
                </p>
                <p>Dec 2024 <br />
                    <i>Certification was issued</i>
                </p>

                <p>
                    Aug 2024 <br />
                    <i>Certification was issued</i>
                </p>
                <p className="feb2022">
                    Feb 2022 <br />
                    <i>Certification was issued</i>
                </p>

                <p className="feb2022">
                    Feb 2022 <br />
                    <i>Certification was issued</i>
                </p>

                <p className="feb20222">
                    Feb 2022 <br />
                    <i>Certification was issued</i>
                </p>

                <p>
                    Jan 2022 <br />
                    <i>Certification was issued</i>
                </p>
            </div>

            <div className="certright">
                <p className="cursor">
                   Hackathon 2nd place <br />
                   <strong>Ethiopian Cursor Community</strong> 
                </p>
                <p className="ai">
                    Artificial Intelligence Fundamentals <br />
                    <strong>UDACITY</strong>
                </p>
                <p className="dataanalysis">
                    Data Analysis Fundamentals <br />
                    <strong>UDACITY</strong> 
                    </p>

                <p className="andriod">
                    Android Developer Fundamentals <br />
                    <strong>UDACITY</strong> 
                    </p>

                <p className="programming">
                    Programming Fundamentals <br />
                    <strong>UDACITY</strong> 
                    </p>

                <p className="evasue">
                    Certificate of Participation in
                    Fellowship <br />
                    <strong>EvaSUE</strong>
                </p>

                <p className="coding1">
                    Certificate of Completion of Coding
                    Fundamentals <br />
                    <strong>GRASSHOPPER</strong>
                </p>
                <p className="coding2">
                    Certificate of Completion of Coding
                    Fundamentals II <br />
                    <strong>GRASSHOPPER</strong>
                </p>
                <p className="coding3">
                    Certificate of Completion of Array Methods <br />
                    <strong>GRASSHOPPER</strong>
                </p>
                <p className="space">
                    Certificate of Participation in Space Science
                    Club <br />
                    <strong>CMMTS SPACE SCIENCE CLUB</strong>
                </p>
            </div>
        </div>
    )
};

export default Certificate;